import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.split.js";
export default (function (cents) {
  var price = cents / 100;
  if (price % 1 === 0) {
    return "$".concat(price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  } else {
    var parts = price.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return "$".concat(parts.join('.'));
  }
});